import { Injectable } from "@angular/core";
import { LoginService } from "../login/login.service";
import { catchError, map, of } from "rxjs";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private loginService: LoginService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.loginService.session().pipe(
      map(() => true),
      catchError(() => {
        localStorage.removeItem("currentUser");
        return of(this.router.createUrlTree(["/login"], { queryParams: { returnUrl: state.url } }));
      })
    );
  }
}
